import React from 'react';
import styled from 'styled-components';

import { GUID } from '@ndvr/auth-api';

import { Breadcrumbs } from '@/components/Breadcrumbs';
import { Breadcrumb, HorizontalLayout, Text, Title, VerticalLayout } from 'widgets';

type InfoBlock =
    | { label: string; value: string | number; centered?: boolean; component?: never }
    | { label?: never; value?: never; centered?: never; component: JSX.Element };

interface IndividualHeaderNavProps {
    breadcrumbs: Breadcrumb[];
    title: string;
    infoBlocks?: InfoBlock[];
    actions?: JSX.Element;
    showBorder?: boolean;
    guid?: GUID<unknown>;
}

export const IndividualHeaderNav = ({
    breadcrumbs,
    actions,
    title,
    infoBlocks,
    showBorder,
    guid,
}: IndividualHeaderNavProps) => {
    return (
        <Wrapper $gap={8} $padding="16px 32px" $showBorder={showBorder}>
            <Breadcrumbs parts={breadcrumbs} />
            <HorizontalLayout $rowCenter $apart>
                <HorizontalLayout $gap={16} $rowCenter>
                    <Title page>{title}</Title>
                </HorizontalLayout>
                <HorizontalLayout $gap={40} $rowCenter>
                    {infoBlocks?.map(({ label, value, centered = false, component }, idx) =>
                        component ? (
                            <React.Fragment key={idx}>{component}</React.Fragment>
                        ) : (
                            <VerticalLayout key={idx} $columnCenter={centered}>
                                <Text>{value}</Text>
                                <Text helper $uppercase $themeColor="subtle">
                                    {label}
                                </Text>
                            </VerticalLayout>
                        ),
                    )}
                </HorizontalLayout>
                <ActionsContainer $pullRight>{actions}</ActionsContainer>
            </HorizontalLayout>
        </Wrapper>
    );
};

const Wrapper = styled(VerticalLayout)<{ $showBorder?: boolean }>`
    ${({ $showBorder = false, theme }) => $showBorder && `border-bottom: 1px solid ${theme.border.light};`}
    height: 94px;
`;

const ActionsContainer = styled(HorizontalLayout)`
    min-width: 150px;
`;
